export enum SelfServiceSessionPages {
  ChangeVehiclePage = 'CV',
  ChangeVehicleLocationPage = 'CVL',
  ChangeVehicleRegistrationPage = 'CVR',
  UpgradeVehiclePage = 'UV',
  ChangeHomePage = 'CHI',
  ChangePaymentDetailsPage = 'CPM',
  DeferPaymentPage = 'DP',
  ChangeMonthlyPaymentPage = 'SMP',
  ReduceMotorPremiumPage = 'RMP',
  ReduceHomePremiumPage = 'RHP',
}
